import { useTranslation } from "react-i18next";
import CategorySelector from '../../../features/Transactions/CategorySelector';
import TransactionTypeSelector, { TransactionTypeOption } from '../../../features/Transactions/TransactionTypeSelector';
import WalletSelector from '../../../features/Transactions/WalletSelector';
import { TransactionType } from "./types";
import {
  getSourceWalletTypes,
  getDestinationWalletTypes,
  getSourceExcludeWalletIds,
  getDestinationExcludeWalletIds,
  getSourceWalletTitle,
  getDestinationWalletTitle,
} from "../helpers";
import { TransactionFormState } from "../hooks/useTransactionFormState";

interface TransactionFormDialogsProps {
  formState: TransactionFormState;
  onTransactionTypeSelect: (option: TransactionTypeOption) => void;
}

const TransactionFormDialogs = ({
  formState,
  onTransactionTypeSelect,
}: TransactionFormDialogsProps) => {
  const { t } = useTranslation(['transactions']);

  const {
    currentTransactionType,
    currentTab,
    loanType,
    creditCardType,
    openTransactionTypeSelector,
    setOpenTransactionTypeSelector,
    openDialogSelectedExpenseCategory,
    openDialogSelectedIncomeCategory,
    openDialogSelectWallets,
    openDialogSelectDestinationWallets,
    setSpendingCategory,
    setIncomeCategory,
    setExpenseWallet,
    setIncomeWallet,
    setTransferSourceWallet,
    setSelectDestinationWallet,
    setOpenDialogSelectWallets,
    setOpenDialogSelectDestinationWallets,
    selectDestinationWallet,
    transferSourceWallet,
    handleOnCloseDialog,
    isManuallyOpeningTypeSelectorRef,
  } = formState;

  return (
    <>
      <CategorySelector
        type="expense"
        open={openDialogSelectedExpenseCategory}
        onClose={handleOnCloseDialog}
        onSelectCategory={(data: any) => {
          setSpendingCategory(data);
        }}
        transactionType={currentTransactionType}
        loanType={loanType}
      />

      <CategorySelector
        type="income"
        open={openDialogSelectedIncomeCategory}
        onClose={handleOnCloseDialog}
        onSelectCategory={(data: any) => {
          setIncomeCategory(data);
        }}
        transactionType={currentTransactionType}
        loanType={loanType}
      />

      <WalletSelector
        open={openDialogSelectWallets}
        onClose={handleOnCloseDialog}
        onSelectWallet={(data: any) => {
          if (currentTab === TransactionType.EXPENSE || (currentTab === TransactionType.LOAN && loanType === 'borrow-expense')) {
            setExpenseWallet(data);
          } else if (currentTab === TransactionType.INCOME) {
            setIncomeWallet(data);
          } else if (currentTab === TransactionType.TRANSFER || currentTab === TransactionType.CREDIT_CARD) {
            setTransferSourceWallet(data);
          }
          setOpenDialogSelectWallets(false);
        }}
        transactionType={currentTransactionType}
        loanType={loanType}
        walletTypes={getSourceWalletTypes(currentTab, creditCardType)}
        excludeWalletIds={getSourceExcludeWalletIds(currentTab, selectDestinationWallet)}
        customTitle={getSourceWalletTitle(currentTab, loanType, creditCardType, t)}
      />

      <WalletSelector
        open={openDialogSelectDestinationWallets}
        onClose={handleOnCloseDialog}
        onSelectWallet={(data: any) => {
          setSelectDestinationWallet(data);
          setOpenDialogSelectDestinationWallets(false);
        }}
        transactionType={currentTransactionType}
        loanType={loanType}
        walletTypes={getDestinationWalletTypes(currentTab, creditCardType)}
        excludeWalletIds={getDestinationExcludeWalletIds(currentTab, transferSourceWallet)}
        customTitle={getDestinationWalletTitle(currentTab, creditCardType, t)}
      />

      <TransactionTypeSelector
        open={openTransactionTypeSelector}
        onClose={() => {
          // Clear the manual opening flag when dialog closes (without selection)
          isManuallyOpeningTypeSelectorRef.current = false;
          setOpenTransactionTypeSelector(false);
        }}
        onSelectTransactionType={onTransactionTypeSelect}
        currentType={currentTab}
        currentLoanType={loanType}
        currentCreditCardType={creditCardType}
      />
    </>
  );
};

export default TransactionFormDialogs;
